import { NgModule } from '@angular/core';
import { BallPulseComponent } from './loadings/ball-pulse/ball-pulse.component';
import { ZerosAEsquerda } from './zeros-a-esquerda.pipe';
import { CommonModule } from '@angular/common';
import { SafePipe } from './safe.pipe';

@NgModule({
    declarations: [
        BallPulseComponent,
        ZerosAEsquerda,
        SafePipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        BallPulseComponent,
        ZerosAEsquerda,
        SafePipe
    ]
})
export class UtilsModule {

}
